import { __awaiter } from "tslib";
import { FileLoadEvent, FileSaveEvent, StateErrorType, } from '@tencent/mega-sdk-protocols';
import LocalServer from '../common/local-server-api';
import ServiceChannel from '../common/service-channel';
import { SUCCESS_CODE } from '../common/constants';
const API_PATH = {
    FILE_STAT: '/local-edit/fileStat',
    LOAD_FILE: '/local-edit/loadFile',
    SAVE_FILE: '/local-edit/saveFile',
};
class MegaFileService {
    constructor(transport) {
        this.version = 1;
        // apis 类接口因是 broker 上直接取值，如果包含内部调用需 arrow function 防止作用域错误
        this.apis = ['stat'];
        this.channels = ['save', 'load'];
        this.supportedExtnames = ['pdf'];
        this.stat = (options) => __awaiter(this, void 0, void 0, function* () {
            const { filePath } = options;
            if (!this.checkIfExtnameSupported(filePath)) {
                return {
                    err: {
                        type: StateErrorType.NotSupported,
                        message: `仅支持 ${this.supportedExtnames.join('/')} 等文件后缀`,
                    },
                    data: null,
                };
            }
            try {
                const { code, message, data } = yield this.localServer.get(API_PATH.FILE_STAT, options);
                if (code !== SUCCESS_CODE) {
                    return {
                        err: {
                            type: StateErrorType.StatError,
                            message: `code: ${code}, message: ${message}`,
                        },
                        data: null,
                    };
                }
                return {
                    err: null,
                    data,
                };
            }
            catch (err) {
                return {
                    err: {
                        type: StateErrorType.StatError,
                        message: err.message,
                    },
                    data: null,
                };
            }
        });
        this.localServer = new LocalServer();
        this.transport = transport;
    }
    load(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { filePath, size, globalPadId } = options;
            const loadChannel = new ServiceChannel(this.transport);
            if (!this.checkIfExtnameSupported(filePath)) {
                throw new Error(`仅支持 ${this.supportedExtnames.join('/')} 等文件后缀`);
            }
            // 请求文档数据
            loadChannel.subscribe(FileLoadEvent.Next, (offset, length) => __awaiter(this, void 0, void 0, function* () {
                const fixedLength = Math.min(size - offset, length);
                try {
                    const fileReadResult = yield this.localServer.getFile(API_PATH.LOAD_FILE, {
                        filePath,
                        offset,
                        length: fixedLength,
                        globalPadId,
                    });
                    if (fileReadResult.code !== SUCCESS_CODE) {
                        throw new Error(`api fail code: ${fileReadResult.code}`);
                    }
                    loadChannel.publish(FileLoadEvent.Chunk, offset, fixedLength, fileReadResult.data);
                }
                catch (err) {
                    loadChannel.publish(FileLoadEvent.Error, err.message);
                }
            }));
            loadChannel.subscribe(FileLoadEvent.End, () => {
                loadChannel.close();
            });
            return Promise.resolve(loadChannel);
        });
    }
    save(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const saveChannel = new ServiceChannel(this.transport);
            void this.saveFile(saveChannel, options);
            return Promise.resolve(saveChannel);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    showItemInFolder(filePath) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Method not implemented.');
        });
    }
    saveFile(saveChannel, options) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { newPath, newTitle } = yield this.localServer.post(API_PATH.SAVE_FILE, options);
                saveChannel.publish(FileSaveEvent.Saved, newPath, newTitle);
            }
            catch (err) {
                saveChannel.publish(FileSaveEvent.Error, JSON.stringify(err));
            }
        });
    }
    checkIfExtnameSupported(filePath) {
        var _a;
        const fileType = (_a = filePath.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        return !!fileType && this.supportedExtnames.includes(fileType);
    }
}
export default MegaFileService;
//# sourceMappingURL=mega-file-service.js.map